import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Section, CTAButton } from './shared';
const plans = [{
  emoji: '📘',
  name: 'MEGAPACK AGENTES DE SEGUROS PRO',
  includes: 'Módulos + 4 Bonos',
  ideal: 'Agente independiente que quiere cerrar más pólizas, recuperar renovaciones y manejar clientes difíciles con IA.',
  oldPrice: '$51.000',
  price: '$19.990',
  cta: 'QUIERO MI MEGAPACK PRO',
  href: 'https://librofy-store.myshopify.com/cart/47909760106717:1',
  featured: false
}, {
  emoji: '',
  name: 'MEGAPACK PRO + ASISTENTE DE IA',
  includes: 'Módulos + 4 Bonos + Sistema Completo de Automatización',
  ideal: 'Agente que además quiere automatizar todos sus trámites, escalar su cartera y convertirse en un agente de alto rendimiento.',
  oldPrice: '$69.000',
  price: '$27.990',
  cta: 'QUIERO EL PRO + ASISTENTE DE IA',
  href: 'https://librofy-store.myshopify.com/cart/47910701957341:1',
  featured: true
}];
export function Pricing() {
  return <Section id="pricing" className="bg-slate-50 py-16 sm:py-24" data-id="element-147" data-mp="3caeaoc9nvlvb">
      <div className="text-center" data-id="element-148" data-mp="3vynisgb71zbg">
        <h2 className="font-display text-2xl font-extrabold text-navy sm:text-4xl" data-id="element-149" data-mp="3w1t6br46ct52">
          💰 ELEGÍ TU MEGAPACK
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-slate-600 sm:text-lg" data-id="element-150" data-mp="9rpb7nrk93vo">
          Menos de lo que cobrás por una sola comisión de un seguro de auto medio.
        </p>
      </div>

      <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-2" data-id="element-151" data-mp="3d97i9szie6v1">
        {plans.map(p => <div key={p.name} className={`relative flex flex-col rounded-2xl p-7 sm:p-8 ${p.featured ? 'border-2 border-gold bg-navy text-white shadow-xl' : 'border border-slate-200 bg-white text-navy shadow-sm'}`} data-id="element-152" data-mp="3i81xym26jfax">
            {p.featured && <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-gold px-4 py-1 font-display text-sm font-bold text-navy-deep shadow" data-id="element-153" data-mp="3ry3lncqmevpb">
                ⭐ Más Elegido
              </span>}

            <h3 className={`font-display text-xl font-extrabold ${p.featured ? 'text-white' : 'text-navy'}`} data-id="element-154" data-mp="2zgiwwkrpubbj">
              {p.emoji ? `${p.emoji} ` : ''}
              {p.name}
            </h3>
            <p className={`mt-2 text-sm font-semibold ${p.featured ? 'text-gold-soft' : 'text-brandgreen'}`} data-id="element-155" data-mp="2mgqillsygxmg">
              {p.includes}
            </p>

            <p className={`mt-4 text-sm leading-relaxed ${p.featured ? 'text-blue-100/85' : 'text-slate-600'}`} data-id="element-156" data-mp="318il2x7nih6r">
              <span className="font-semibold" data-id="element-157" data-mp="28hqtye5g0iqa">Ideal para:</span> {p.ideal}
            </p>

            <div className="mt-6" data-id="element-158" data-mp="23ixfaief6loj">
              <span className={`text-lg line-through ${p.featured ? 'text-blue-200/70' : 'text-slate-400'}`} data-id="element-159" data-mp="23jp8jmkjo7bn">
                {p.oldPrice}
              </span>
              <div className="mt-1 flex items-baseline gap-2" data-id="element-160" data-mp="2idty1pjuurfv">
                <span className="font-display text-4xl font-extrabold text-gold" data-id="element-161" data-mp="2dfim99a026v0">{p.price}</span>
                <span className={`text-sm font-semibold ${p.featured ? 'text-blue-100' : 'text-slate-500'}`} data-id="element-162" data-mp="3tts8nxuollj7">
                  ARS
                </span>
              </div>
            </div>

            <div className="mt-auto pt-7" data-id="element-163" data-mp="9m12cuxdk8k">
              <CTAButton size="lg" className="w-full" variant={p.featured ? 'gold' : 'navy'} href={p.href} target="_self" data-id="element-164" data-mp="59gqsd2ys3s1">
                {p.cta}
              </CTAButton>
            </div>
          </div>)}
      </div>
    </Section>;
}